import $ from 'jquery';

export default class ScrollToElement {
    constructor(element, offsetTop) {
        this.element = element;
        this.offsetTop = offsetTop || 0;
    }

    handleClick() {
        if (!this.element) return;

        this.element.addEventListener('click', e => {
            e.preventDefault();

            scrollToElement(getElementToScrollTo(e.currentTarget), this.offsetTop);
        });
    }
}

function getElementToScrollTo(element) {
    let toElementId = element.getAttribute('data-scrollto');

    if (toElementId.indexOf('#') === 0) {
        toElementId = toElementId.split('#')[1];
    }

    return document.getElementById(toElementId);
}

function getTopPositionFromViewport(element) {
    return element.getBoundingClientRect().top + window.pageYOffset;
}

function scrollToElement(toElement, offsetTop) {
    if (toElement) {
        $('html, body').animate(
            {
                scrollTop: getTopPositionFromViewport(toElement) - offsetTop,
            },
            500
        );
    }
}



// WEBPACK FOOTER //
// ./src/web/js/contest/ui/scroll-to-element.js